export const autocompleteQueryKeys = {
    pageAll: (agentId: number) => ['page-autocomplete', 'agent', agentId]
} as const;
